import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getExpiredReturns = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/ExpiredReturn/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching expired returns:", error);
    throw error;
  }
};

export const getExpiredReturnById = async (expiredReturnId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/ExpiredReturn/getbyid`, { ExpiredReturn_Id: expiredReturnId }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching expired return by ID:", error);
    throw error;
  }
};

export const saveExpiredReturn = async (expiredReturnData) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/ExpiredReturn/save`, expiredReturnData, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error saving expired return:", error);
    throw error;
  }
};

export const getNextExpiredReturnNo = async (businessId) => {
  try {
    const url = businessId ? `${BASE_URL}/api/ExpiredReturn/getnextreturnno?businessId=${businessId}` : `${BASE_URL}/api/ExpiredReturn/getnextreturnno`;
    const response = await axios.get(url, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting next expired return number:", error);
    throw error;
  }
};

export const getStockForExpiredReturn = async (productId, branchId, businessId = null) => {
  try {
    const payload = {
      Product_Id: productId,
      Branch_Id: branchId,
      Business_Id: businessId
    };
    const response = await axios.post(`${BASE_URL}/api/ExpiredReturn/get-stock`, payload, {
      headers: getAuthHeader(),
    });
    return response.data; // { stockItems, hasExpiredStock, hasCloseToExpiryStock, totalAvailableStock, success, message }
  } catch (error) {
    console.error("Error fetching stock for expired return:", error);
    throw error;
  }
};
